import familyApi from '@/apis/family/api';
import { useQuery } from '@tanstack/react-query';

const familyService = {
  useGetFamilies: (data?: { search?: string; page?: number; limit?: number }) => {
    const { page = 1, limit = 20, search } = data || {};

    return useQuery({
      queryKey: ['families', limit, search, page],
      queryFn: () => familyApi.get({ page, search, limit }),
    });
  },
};

export default familyService;
